/* Huvona wishlist: browser-persistent hearts and Wishlist page rendering. */
(function () {
  const KEY = 'hv:wishlist';

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    const unique = Array.from(new Set(items.filter(Boolean))).slice(0, 100);
    try { localStorage.setItem(KEY, JSON.stringify(unique)); } catch (e) {}
    return unique;
  }

  function setButton(button, active) {
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function flyToWishlist(button) {
    const source = button.querySelector('svg');
    const target = Array.from(document.querySelectorAll('.hv-bar__side--right a[href*="wishlist"]')).find(function (link) {
      const rect = link.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
    if (!source || !target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const destination = target.querySelector('svg') || target;
    const start = source.getBoundingClientRect();
    const end = destination.getBoundingClientRect();
    if (!start.width || !start.height || !end.width || !end.height) return;

    const heart = source.cloneNode(true);
    heart.setAttribute('aria-hidden', 'true');
    heart.setAttribute('data-hv-wish-flight', '');
    heart.style.cssText = 'position:fixed;left:' + start.left + 'px;top:' + start.top + 'px;width:' + start.width + 'px;height:' + start.height + 'px;margin:0;z-index:2147483647;pointer-events:none;transform-box:fill-box;transform-origin:center;color:#d6001c;fill:#d6001c;stroke:#d6001c;';
    document.body.appendChild(heart);

    const x = end.left + end.width / 2 - (start.left + start.width / 2);
    const y = end.top + end.height / 2 - (start.top + start.height / 2);
    const flight = heart.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + x * 0.55 + 'px, ' + (y * 0.55 - 54) + 'px) scale(.82)', opacity: 1, offset: .55 },
      { transform: 'translate(' + x + 'px, ' + y + 'px) scale(.2)', opacity: 0, offset: 1 }
    ], { duration: 900, easing: 'cubic-bezier(.22,.7,.25,1)' });
    flight.onfinish = function () { heart.remove(); };

    const targetIcon = target.querySelector('svg');
    if (targetIcon) {
      targetIcon.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }],
        { duration: 360, easing: 'ease-out' }
      );
    }
  }

  function sync(scope) {
    const saved = new Set(read());
    (scope || document).querySelectorAll('[data-wish]').forEach(function (button) {
      setButton(button, saved.has(button.getAttribute('data-wish')));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = saved.size ? String(saved.size) : '';
      node.hidden = saved.size === 0;
    });
  }

  async function renderPage() {
    const host = document.querySelector('[data-wishlist-page]');
    if (!host || host.__wishlistRendered) return;
    host.__wishlistRendered = true;

    const grid = host.querySelector('[data-wishlist-grid]');
    const empty = host.querySelector('[data-wishlist-empty]');
    const loading = host.querySelector('[data-wishlist-loading]');
    const keys = read();

    if (!keys.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    const cards = await Promise.all(keys.map(function (key) {
      const parts = key.split('::');
      const handle = parts[0];
      const variantId = parts[1] || '';
      const suffix = variantId ? '?variant=' + encodeURIComponent(variantId) + '&view=card' : '?view=card';
      return fetch('/products/' + encodeURIComponent(handle) + suffix)
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; });
    }));

    const valid = cards.map(function (html, index) {
      if (!html) return '';
      const key = keys[index];
      const remove = '<button class="hvwish__remove" type="button" data-wish="' + key + '" aria-pressed="true" aria-label="Remove from wishlist">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
        '<path d="M12 20.5s-7.5-4.7-7.5-9.6A4.4 4.4 0 0 1 12 8.3a4.4 4.4 0 0 1 7.5 2.6c0 4.9-7.5 9.6-7.5 9.6Z"/></svg></button>';
      return '<li class="hvwish__item" data-wishlist-item="' + key + '">' + remove + html + '</li>';
    }).filter(Boolean);

    if (loading) loading.hidden = true;
    if (!valid.length) {
      write([]);
      if (empty) empty.hidden = false;
      return;
    }

    grid.innerHTML = valid.join('');
    grid.hidden = false;
    sync(grid);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wish]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const handle = button.getAttribute('data-wish');
    if (!handle) return;

    let items = read();
    const active = items.includes(handle);
    items = active ? items.filter(function (item) { return item !== handle; }) : [handle].concat(items);
    write(items);
    sync();

    if (!active) {
      flyToWishlist(button);
      button.classList.remove('is-wish-animating');
      void button.offsetWidth;
      button.classList.add('is-wish-animating');
      window.setTimeout(function () {
        button.classList.remove('is-wish-animating');
      }, 700);
    }

    const pageItem = button.closest('[data-wishlist-item]');
    if (active && pageItem) {
      pageItem.remove();
      const grid = document.querySelector('[data-wishlist-grid]');
      const empty = document.querySelector('[data-wishlist-empty]');
      if (grid && !grid.children.length && empty) {
        grid.hidden = true;
        empty.hidden = false;
      }
    }
  });

  function init() {
    sync();
    renderPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', sync);
  window.hvWishlistSync = sync;
})();